module.exports = __webpack_public_path__ + "static/media/bphtb3.0ed401da.png";